<template>
  <div class="license">
    <subtitle>Новая лицензия</subtitle>

    <form class="license-form">
      <custom-input
        id="newLicenseKey"
        inputType="text"
        placeholder="Введите номер ключа"
        labelText="Ключ новой лицензии"
        v-model="licenseKey"
        class="license-form-input"
        @keydown.enter.prevent="activate"
        :errorMessage="errors['newLicenseKey']"
        required
        :inputValue="licenseKey"
      />

      <main-button
        :class="[
          'license-form-button',
          {
            'license-form-button_invalid': Boolean(errors['newLicenseKey']),
          },
        ]"
        @click="activate"
        type="button"
        :loading="loading"
        color="secondary-fill"
      >
        Активировать
      </main-button>
    </form>

    <subtitle>Текущие лицензии</subtitle>

    <div v-if="$auth.user().license" class="license-table">
      <div class="license-table-header">
        <p :key="key" v-for="{ key, label } in headerFields" class="license-table-header-item">{{ label }}</p>
      </div>

      <div :key="item.key" v-for="(item, index) in $auth.user().license" class="license-table-row">
        <div class="license-table-row-item">
          <p class="license-table-row-text">{{ item.key }}</p>
        </div>

        <div class="license-table-row-item">
          <p class="license-table-row-text" v-if="item.activated_at">
            {{ parseInt(item.activated_at) | moment("timezone", $moment.tz.guess(), "lll") }}
          </p>
          <p class="license-table-row-text" v-else>–</p>
        </div>

        <div class="license-table-row-item">
          <p class="license-table-row-text" v-if="item.activated_at">
            {{ (parseInt(item.activated_at) + parseInt(item.time)) | moment("timezone", $moment.tz.guess(), "lll") }}
          </p>
          <p class="license-table-row-text" v-else>–</p>
        </div>

        <div class="license-table-row-item">
          <div v-if="!item.activated_at">
            <button class="license-table-row-button" @click="activateKey(item.id, index)">Активировать</button>
          </div>

          <main-badge
            class="license-table-row-badge"
            content="Активен"
            variant="success"
            v-else-if="parseInt(item.activated_at) + parseInt(item.time) > parseInt(new Date().getTime() / 1000)"
          />
          <main-badge class="license-table-row-badge" v-else content="Истёк" variant="warning" />
        </div>
      </div>
    </div>
    <div v-if="!$auth.user().license">Отсутствуют</div>
  </div>
</template>

<script>
import Subtitle from "../components/ui/Subtitle.vue";
import Input from "../components/ui/Input.vue";
import MainButton from "../components/ui/MainButton.vue";
import MainBadge from "../components/ui/MainBadge.vue";
export default {
  data() {
    return {
      loading: false,
      licenseKey: "",
      errors: {},
      headerFields: [
        { key: "key", label: "Ключ" },
        { key: "activated_at", label: "Активирован" },
        { key: "time", label: "Истекает" },
        { key: "status", label: "Статус" },
      ],
    };
  },
  components: {
    Subtitle,
    MainButton,
    MainBadge,
    "custom-input": Input,
  },
  methods: {
    activate() {
      this.errors = {};

      if (!this.licenseKey) {
        this.errors["newLicenseKey"] = "Необходимо заполнить поле";
        return;
      }

      this.$http
        .get("profile/license", {
          params: {
            key: this.licenseKey,
          },
        })
        .then((response) => {
          this.$auth.user().license.push(response.data);
        })
        .catch((err) => {
          if (err.response.data) {
          }
          console.error(err);
        });
    },

    activateKey(id, index) {
      this.$http
        .get("profile/activate-key", {
          params: {
            id: id,
          },
        })
        .then((response) => {
          this.$set(this.$auth.user().license, index, response.data);
        })
        .catch((e) => {
          alert(e.response.data);
        });
    },
  },
};
</script>

<style scoped>
.license {
  width: 850px;
  padding: 0 24px 32px 24px;
  overflow: auto;
}
.license-form {
  display: flex;
  align-items: flex-end;
  margin-top: 16px;
  margin-bottom: 32px;
}
.license-form-input {
  max-width: 600px;
  margin-bottom: 0;
}
.license-form-button {
  height: 36px;
  margin-left: 32px;
}
.license-form-button_invalid {
  margin-bottom: 21px;
}
.license-table {
  margin-top: 16px;
}
.license-table-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  padding: 0 16px;
  background-color: var(--background-color);
}
.license-table-header-item {
  font-family: "Ubuntu", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: var(--grey-3-color);
  padding: 12px 0;
  margin: 0;
}
.license-table-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  padding: 16px;
  background-color: var(--white-color);
  box-shadow: 0px 1px 0px 0px var(--grey-color) inset;
}
.license-table-row-badge {
  padding: 4px 12px;
  width: max-content;
}
.license-table-row-text {
  font-family: "Ubuntu", sans-serif;
  font-size: 14px;
  line-height: 16px;
  color: var(--black-color);
  margin: 0;
}
.license-table-row-button {
  font-family: "Ubuntu", sans-serif;
  font-size: 14px;
  line-height: 16px;
  color: var(--primary-color);
  margin: 0;
  background-color: transparent;
  border: none;
}
</style>
